export const SRC_ROOT = "https://github.com/cxa/uilabs/blob/main/src";
